function convertDayToHour(num) {
  let eq =
    "Converting " +
    num +
    " day to hour: \n" +

    num + " * 24 = ";
  let rep = num * 24 ;
  return eq + rep.toFixed(2);
}

function convertDayToMinute(num) {
  let eq = "Converting " + num + " day to minute: \n" +
    num + " * 1440 = ";
  let rep = num * 1440;
  return eq + rep.toFixed(2);
}

function convertDayToMonth(num) {
  let eq =
    "Converting " +
    num +
    " day to month: \n" +
    num +
    " * 0.03285 = ";
  let rep = num * 0.03285;
  return eq + rep.toFixed(4);
}

function convertDayToSecond(num) {
  let eq =
    "Converting " +
    num +
    " day to second: \n" +
    num +
    " * 86400 = ";
  let rep = num * 86400  ;
  return eq + rep.toFixed(2);
}

function convertDayToWeek(num) {
  let eq =
    "Converting " +
    num +
    " day to week: \n" +
    num +
    " * 0.14286 = ";
  let rep = num * 0.14286;
  return eq + rep.toFixed(3);
}

function convertDayToYear(num) {
  let eq =
    "Converting " +
    num +
    " day to year: \n" +
    num +
    " * 0.00274 = ";
  let rep = num * 0.00274 ;
  return eq + rep.toFixed(5);
}

export {
  convertDayToHour,
  convertDayToYear,
  convertDayToWeek,
  convertDayToSecond,
  convertDayToMonth,
  convertDayToMinute
};
